/* eslint-disable no-undef */
$(() => {

    // Set scrolling header ui by observing main nav relative to viewport
    let scrolledAubreyFeeds = document.querySelector("#digital-collections"),
        scrolledAubreyFeedsObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.intersectionRatio > 0) {

              console.log('in the view');
              scrolledAubreyFeedsObserver.unobserve( entry.target );

              $.when($.get('https://digital.library.unt.edu/explore/collections/feed/'),
                $.get('https://texashistory.unt.edu/explore/collections/feed/'))
                .done((dataDigital, dataPTH) => {
                  const $cardHeader = $('<div class="card-header text-dark">New Digital Collections</div>');
                  const $listGroup = $('<div class="list-group list-group-flush"></div>');
                  const entriesDigital = $(dataDigital[0]).find('entry').toArray();
                  const entriesPTH = $(dataPTH[0]).find('entry').toArray();
                  const entries = entriesDigital.concat(entriesPTH);
                  const limitedData = _.sampleSize(entries, 4);

                  $(limitedData).each(function () {
                    const $this = $(this);
                    const href = $this.find('link').attr('href');
                    const title = $this.find('title').text();
                    const $title = $('<a></a>')
                      .attr({ href, class: 'list-group-item' })
                      .append(title);

                    $listGroup.append($title);
                  });
                  $('#digital-collections-recent-collections').append($cardHeader, $listGroup);
                });
            }
          });
    });
    // do the observing
    scrolledAubreyFeedsObserver.observe( scrolledAubreyFeeds );

});